import { Menu, Transition } from '@headlessui/react'
import { Link } from 'gatsby'
import { StaticImage } from 'gatsby-plugin-image'
import React, { Fragment } from 'react'

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

interface NavbarMenuProps {
  isLogin: boolean
  handleSignOut: () => void
}

export default function NavbarMenu({ isLogin, handleSignOut }: NavbarMenuProps) {
  const dogDetailsPage = 'dog-details'

  const isSignupPage =
    location?.pathname?.includes('/signup/thankyou') ||
    location?.pathname?.includes('/signup/add-treats') ||
    location?.pathname?.includes('/signup/supplements')
      ? true
      : false

  return (
    <Menu
      as="div"
      className={`relative inline-block text-left ${
        isLogin && isSignupPage ? 'inline-block mr-0' : 'hidden sm:inline-block mr-2'
      }`}
    >
      <div>
        <Menu.Button className="inline-flex w-full justify-center rounded-full p-4 text-sm hover:bg-white focus:bg-white">
          <StaticImage className="flex w-8 h-auto" src="../../../images/login.svg" alt="Login" />
        </Menu.Button>
      </div>

      <Transition
        as={Fragment}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items className="absolute right-0 z-50 mt-2 w-56 origin-top-right rounded-xl bg-white shadow-lg flex items-center justify-center">
          <div className="py-1">
            {!isLogin && location.pathname.includes('/account/signin') && (
              <Menu.Item>
                {({ active }) => (
                  <Link
                    to={`/signup/${dogDetailsPage}/`}
                    className={classNames(
                      active ? 'bg-ddBlue text-gray-900' : 'text-gray-700',
                      'block px-4 py-2 text-sm '
                    )}
                  >
                    Sign up
                  </Link>
                )}
              </Menu.Item>
            )}
            {!isLogin && !location.pathname.includes('/account/signin') && (
              <Menu.Item>
                {({ active }) => (
                  <Link
                    to="/account/signin"
                    className={classNames(
                      active ? 'bg-ddBlue text-gray-900' : 'text-gray-700',
                      'block px-4 py-2 text-sm'
                    )}
                  >
                    Log in
                  </Link>
                )}
              </Menu.Item>
            )}
            {isLogin && !location.pathname.includes('account') && (
              <Menu.Item>
                {({ active }) => (
                  <Link
                    data-testid="account"
                    to="/account"
                    className={classNames('block px-4 py-2 text-sm text-[#5F6977] font-sans')}
                  >
                    Account
                  </Link>
                )}
              </Menu.Item>
            )}
            {isLogin && (
              <Menu.Item>
                {({ active }) => (
                  <Link
                    to="#"
                    className={classNames('block px-4 py-2 text-sm text-[#5F6977] font-sans')}
                    onClick={handleSignOut}
                  >
                    Sign out
                  </Link>
                )}
              </Menu.Item>
            )}
          </div>
        </Menu.Items>
      </Transition>
    </Menu>
  )
}
